var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 79.5,
    width: 79,
    height: 79,
    rx: 39.5,
    transform: "rotate(180 79.5 79.5)",
    stroke: "#D89477"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3957 37.3763L42.8393 31.1066C39.9021 28.2978 35.14 28.2978 32.2029 31.1066C29.2657 33.9153 29.2657 38.4692 32.2029 41.2779L40.7872 49.4869C42.8914 51.4991 46.3009 51.5051 48.4129 49.5005C50.518 47.5022 50.5306 44.2504 48.441 42.2373C48.4364 42.2328 45.5628 39.4849 39.8203 33.9935C38.5505 32.7792 36.4917 32.7792 35.2219 33.9935C33.952 35.2078 33.952 37.1766 35.2219 38.391L41.7783 44.6607L43.3884 43.121L36.832 36.8512C36.4514 36.4873 36.4514 35.8972 36.832 35.5332C37.2126 35.1693 37.8296 35.1693 38.2102 35.5332L46.8168 43.7636C48.0286 44.9309 48.0213 46.804 46.8087 47.955C45.587 49.1147 43.6146 49.1112 42.3973 47.9472L33.813 39.7382C31.7651 37.7798 31.7651 34.6047 33.813 32.6463C35.8609 30.6879 39.1813 30.6879 41.2292 32.6463L47.7856 38.916L49.3957 37.3763Z",
    fill: "#D89477"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.a16bc6db38bce453c5519899afaf651d.svg";
export { ForwardRef as ReactComponent };